// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import root from './components/root.vue'
import store from './vuex'
import router from './router'
import firebase from "firebase";

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)

Vue.config.productionTip = false

// Initialize Firebase
firebase.initializeApp(process.env.FB_CONFIG);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    root
  },
  template: '<root />',
})



// WEBPACK FOOTER //
// ./src/main.js